export const EMPTY_QUERY_LIMIT = 0;
export const LIMIT_CHARACTERS_FOR_QUERY = 2;
